import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap"
import { useBoolean } from '@fluentui/react-hooks';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { useGetSectionsByBookId } from '../../../../../hooks/services/sBook/useOfSection'
import SecctionCard from '../../SectionCreationBox/SecctionCard';



function SidePanelSections(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_BookObject = props.bookObject !== null && props.bookObject !== undefined ? props.bookObject : null;
    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;

    //Parametros de componente.
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    
    const [bookSectionList, setBookSectionList] = useState(null);
    useGetSectionsByBookId(inputParam_BookObject.id, bookSectionList, setBookSectionList, null, false, false, [], inputParam_IsPanelOpen)

    //Funciones de componente.

    //Eventos de componente.

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
    };

    const onRenderFooterContent = () => {
        return <div>
            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
        </div>
    };

    //Render de componente.
    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-sidepanel-listsections') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-3">
                    {
                        bookSectionList && bookSectionList.data.data.map((section, index) => 
                            <Col key={ index } xxl={ 12 } className="pt-3">
                                <SecctionCard editMode={ false } bookId={ inputParam_BookObject.id } sectionItem={ section } setterDeleteSection={ null } setterSelectedCard={ null } />
                            </Col>
                        )
                    }
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
}

export default SidePanelSections;